import * as React from 'react'
// import { ServerBlockNoteEditor } from "@blocknote/server-util";
import { BlockNoteEditor } from '@blocknote/core'
import {PartialBlock} from '@blocknote/core/src/blocks/defaultBlocks'

export async function generateHtmlFromEditorJson(editorJson: string | PartialBlock[] | null) {
  const content: PartialBlock[] = typeof editorJson === 'string' ? JSON.parse(editorJson) : editorJson

  if (content) {
    const editor = BlockNoteEditor.create()
    return editor.blocksToFullHTML(content)
  }

  return Promise.resolve(null)

  // if (content) {
  //   const editor = ServerBlockNoteEditor.create()
  //   return editor.blocksToFullHTML(content)
  // }
  // return Promise.resolve(null)
}
export function generatePlainTextFromEditorJson(editorJson: string | PartialBlock[] | null) {
  const content: PartialBlock[] = typeof editorJson === 'string' ? JSON.parse(editorJson) : editorJson

  if (content) {
    const editor = BlockNoteEditor.create({ initialContent: content })
    return editor._tiptapEditor.getText()
  }

  return ''
}

export function generatePlainTextShortDescription(editorJson: string | PartialBlock[] | null, maxLength: number | null = null) {
  try {
    const text = generatePlainTextFromEditorJson(editorJson)
      .split('\n')
      .join(' ')

    if (maxLength) {
      return `${text.slice(0, 150)} ${text.length > 150 ? '...' : ''}`
    }
  } catch {
    return editorJson
  }
}

export const useBlockNoteJsonToHtml = ({ json = '' }: { json?: string | PartialBlock[] | null }) => {
  const [htmlString, setHtmlString] = React.useState('')

  React.useLayoutEffect(() => {
    void generateHtmlFromEditorJson(json).then(html => {
      setHtmlString(html ?? '')
    })
  }, [json])

  return htmlString
}

export const useTipTapJsonToPlainText = ({ json = '', maxLength = null }: { json?: string | null, maxLength?: number | null }) => {
  const output = React.useMemo(() => generatePlainTextShortDescription(json, maxLength), [maxLength, json])

  return output
}
